module.exports = __webpack_public_path__ + "img/wallet-part2-ft.98f3046d.png";